import moment from "moment";
import { ReportLayer } from "../com/reportLayer";
import { GoodsSalesRankingTable } from "./tableShow/goodsSalesRankingTable";
import { useState, useEffect } from "react";
import { DateSelect } from "./select/dateSelect";
import { Buttons } from "./com/buttons";
import { SearchLayer } from "./search/searchLayer";
import { ApiCon } from "../com/apiCon";
import { SelectStore } from "./store/SelectStore";
import { ISelectTime, ISelectGoods, ISpeedQuery } from "../com/ISelectType";
import { SelectGoods } from "./select/selectGoods";
import { Form, Select, message } from "antd";
import { QueryType } from "../com/QueryType";
import { useDebounceFn } from "ahooks";
import { SelectShop } from "./select/selectShop";
const { Option } = Select;

/**
 * 商品销售排行
 */
export function GoodsSalesRanking(viewPower) {
  const [data, setData] = useState(null);
  const [ifInit, setIfInit] = useState(false);
  const [ifLastPage, setIfLastPage] = useState(false);
  const [queryType, setQueryType] = useState<QueryType>("n");
  const [queryState, setQueryState] = useState<
    {
      /** 排行类型1:销售额排行 2:销量排行 3:毛利排行 */
      rankType?: number;
    } & ISelectTime &
      ISelectGoods &
      ISpeedQuery
  >({
    seacherKey: "",
    beginTime: moment(Date.now()).startOf("month").format("Y-M-D"),
    endTime: moment(Date.now()).format("Y-M-D"),
    goodsClassID: [],
    goodsID: [],
  });
  const [paging, setPaging] = useState<{
    pageSize: number;
    current: number;
    total: number;
  }>({
    pageSize: 20,
    current: 1,
    total: 0,
  });

  useEffect(() => {
    if (!ifInit) {
      setIfInit(true);
      queryClick();
    }
  });

  const queryClick = (_queryType: QueryType = queryType) => {
    setQueryType(_queryType);
    let op: any = {
      ...queryState,
      ...{
        pageIndex: paging.current,
        pageSize: paging.pageSize,
      },
    };
    //根据不同的查询模式修剪参数
    switch (_queryType) {
      case "c":
        op.seacherKey = "";
        break;
      case "s":
        break;
      case "n":
        op.seacherKey = "";
        break;
    }
    ApiCon.GoodsSaleRankReport(op)
      .then((data) => {
        //console.log('商品销售排行数据', data);
        setPaging({
          ...paging,
          total: data.totalCount,
        });
        setIfLastPage(!data.hasNextPage);
        if (data.dataSource) {
          setData(data.dataSource);
        } else {
          setData({
            list: [],
          });
        }
      })
      .catch((data) => {
        setData({
          list: [],
        });
        //提示
        message.error(data.message);
      });
  };

  const setQuery = (query) => {
    setQueryState({
      ...queryState,
      ...query,
    });
  };
  const { run } = useDebounceFn(
    (fn) => {
      fn && fn();
    },
    {
      wait: 1500,
    }
  );
  return (
    <SelectStore.Provider
      value={{
        state: queryState,
        dispatch: setQuery,
      }}
    >
      <ReportLayer
        queryItem={
          <SearchLayer
            queryClick={queryClick}
            speedQureyPlaceholder="请输入商品分类，商品名称，商品编码"
          >
            <SelectGoods />
            <div className="item_">
              <Form.Item label="排行类型">
                <Select
                  style={{ width: 175 }}
                  allowClear
                  value={queryState.rankType}
                  onChange={(value) => {
                    setQuery({ rankType: value });
                  }}
                >
                  <Option value={1}>销售额排行</Option>
                  <Option value={2}>销量排行</Option>
                  <Option value={3}>毛利排行</Option>
                </Select>
              </Form.Item>
            </div>
            <SelectShop/>
            <DateSelect />
          </SearchLayer>
        }
        button={
          (
           <Buttons
             exportExcel={() => {
               run(async () => {
               let today = moment(Date.now()).format("yyyy-MM-DD")
                 const r = await ApiCon.exportExcel('export_table',`商品销售排行${today}.xlsx`);
               });
             }}
           />
         )
       }
        paging={{
          ...paging,
          onChange: (page, pageSize) => {
            paging.current = page;
            paging.pageSize = pageSize;
            setPaging({
              ...paging,
            });
            queryClick();
          },
        }}
      >
        <GoodsSalesRankingTable data={data} ifLastPage={ifLastPage} />
      </ReportLayer>
    </SelectStore.Provider>
  );
}
